<template>
    <div>

           <v-card-title>
            <v-spacer/>
            <v-btn @click="$router.push('listaMedicosUnidade')">
                Cadastros
            </v-btn>
           </v-card-title>

            <v-row class="mx-1">
                <v-col xl="3" lg="3" md="4" sm="6" xs="12"
                v-for="(item, i) in stats"
                :key="i"
                >

                <v-card
                    max-width="350"
                    height="120"
                    color="white"
                    class="ma-3 rounded-xl"
                >

                    <v-card flat v-if="load">
                      <v-row>
                        <v-col cols="9">
                          <v-skeleton-loader
                            type="card-heading"
                          ></v-skeleton-loader>
                          <v-skeleton-loader
                            class="ml-4"
                            type="text"
                          ></v-skeleton-loader>
                        </v-col>
                        <v-col cols="3">
                          <v-skeleton-loader
                            type="avatar"
                          ></v-skeleton-loader>
                        </v-col>
                      </v-row>
                    </v-card>

                    <v-card flat v-if="!load">
                      <div class="d-flex flex-no-wrap justify-space-between">
                          <div>
                          <v-card-text
                              class="mb-0 mt-0"
                              style="font-weight: normal; color: grey; font-size: 18px;"
                          >
                              {{item.title}}
                              <div
                                class="mt-2 mb-0"
                                style="font-weight: bold; font-size: 22px; color: #344767"
                              >
                                <span> {{item.value}}</span>
                              </div>
                              <div class="d-flex mt-1">
                                <div class="mr-2" :style="{ 'font-weight': 'normal', 'font-size': '14px', 'color': item.colorPercentage }">
                                    {{item.percentage}}%
                                </div>
                                <div style="font-weight: normal; font-size: 14px; color: grey; display: flex;">
                                    {{item.detail}} &nbsp; <b>{{ item.lastMonth }}</b>

                                </div>
                              </div>
                          </v-card-text>
                          </div>
                          <v-avatar
                              class="ma-3"
                              size="47"
                              :color="item.iconBackground"
                          >
                          <v-icon dark color="white">{{item.icon}}</v-icon>
                          </v-avatar>
                      </div>
                    </v-card>

                </v-card>

                </v-col>
            </v-row>

            <v-row>

            <v-col cols="12">
                <v-card
                class="mx-auto rounded-xl"
                max-width="600"
            >
            <v-carousel v-model="carrousel">
              <v-carousel-item
                v-for="i in 2"
                :key="i"
              >
                <v-sheet
                  height="100%"
                  tile

                >
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center"
                  >
                    <v-card flat v-show="carrousel == 0">
                      <v-card-title>
                          Top 5 Médicos [Média tempo de Atendimentos]
                      </v-card-title>
                      <v-card-subtitle>
                          <v-list flat>
                          <v-list-item-group
                              v-model="model"
                              color="indigo"
                          >
                              <v-list-item
                              v-for="(item, i) in top5MediaAtendimentos"
                              :key="i"
                              >
                              <v-list-item-icon>
                                  <v-avatar
                                      size="35"
                                      color="blue"
                                  >
                                      <div style="color: white">{{ i +1 }}</div>
                                  </v-avatar>

                              </v-list-item-icon>

                              <v-list-item-content>
                                  <v-list-item-title v-text="item.nome"></v-list-item-title>
                                  <v-list-item-subtitle v-text="item.media.toFixed(2) + ' minutos'"></v-list-item-subtitle>
                              </v-list-item-content>
                              </v-list-item>
                          </v-list-item-group>
                          </v-list>
                      </v-card-subtitle>
                    </v-card>

                    <v-card flat v-show="carrousel == 1">
                      <v-card-title>
                          Top 5 Médicos [Solicitações de Exames]
                      </v-card-title>
                      <v-card-subtitle>
                          <v-list flat>
                          <v-list-item-group
                              v-model="model"
                              color="indigo"
                          >
                              <v-list-item
                              v-for="(item, i) in top5Solicitacoes"
                              :key="i"
                              >
                              <v-list-item-icon>
                                  <v-avatar
                                      size="35"
                                      color="blue"
                                  >
                                      <div style="color: white">{{ i +1 }}</div>
                                  </v-avatar>

                              </v-list-item-icon>

                              <v-list-item-content>
                                  <v-list-item-title v-text="item.nome"></v-list-item-title>
                                  <v-list-item-subtitle v-text="item.numeroSolicitacoes + ' solicitações'"></v-list-item-subtitle>
                              </v-list-item-content>
                              </v-list-item>
                          </v-list-item-group>
                          </v-list>
                      </v-card-subtitle>
                    </v-card>
                  </v-row>
                </v-sheet>
              </v-carousel-item>
            </v-carousel>

            </v-card>
            </v-col>
            <v-col cols="4">
            <v-card
                class="mx-auto rounded-xl"
                max-width="400"
            >
            </v-card>
            </v-col>

            </v-row>

    </div>
</template>

<script>
import medicoService from '../../../services/medico.service'
export default {
  data () {
    return {
      user: {},
      model: '',
      load: true,
      load2: true,
      carrousel: 0,
      stats: [
        {
          title: 'Tempo por atendimento',
          value: '13:47',
          percentage: '3',
          colorPercentage: '',
          lastMonth: '200',
          detail: 'maior que o último mês',
          icon: 'mdi-account-clock',
          iconBackground: 'purple'
        },
        {
          title: 'Médicos cadastrados',
          value: '35',
          percentage: '',
          colorPercentage: '',
          lastMonth: '',
          detail: '',
          icon: 'mdi-doctor',
          iconBackground: 'accent'
        },
        {
          title: 'Total de atendimentos',
          value: '250',
          percentage: '5',
          colorPercentage: '',
          lastMonth: '200',
          detail: 'maior que o último mês',
          icon: 'mdi-medication',
          iconBackground: 'green'
        },
        {
          title: 'Exames Solicitados',
          value: '400',
          percentage: '3',
          colorPercentage: '',
          lastMonth: '',
          detail: 'maior que o último mês',
          icon: 'mdi-medical-bag',
          iconBackground: 'yellow'
        },
        {
          title: 'Medicamentos Solicitados',
          value: '400',
          percentage: '3',
          colorPercentage: '',
          lastMonth: '',
          detail: 'maior que o último mês',
          icon: 'mdi-pill',
          iconBackground: 'blue'
        }

      ],
      top5MediaAtendimentos: [
        {
          nome: '',
          media: ''
        }
      ],
      top5Solicitacoes: [
        {
          nome: '',
          numeroSolicitacoes: ''
        }
      ],
      exames: [
        {
          title: 'Hemograma',
          value: '300'
        },
        {
          title: 'Hemoglobina Glicada',
          value: '250'
        },
        {
          title: 'T3 e T4',
          value: '200'
        },
        {
          title: 'Fezes e Urina',
          value: '150'
        },
        {
          title: 'Fezes e Urina',
          value: '100'
        }

      ]
    }
  },
  mounted () {
    this.user = this.$store.getters.usuario
    this.retornarMetricasMedico()
    this.retornarTop5()
  },
  methods: {
    retornarMetricasMedico () {
      this.load = true
      medicoService.medico.retornarMetricasMedico(this.user.idUnidade).then(r => {
        if (r.status == 200) {
          console.log('tempo medico consulta ', r.data)

          this.stats[0].value = r.data.tempoMedioConsultas[1].tempoMedioAtendimento.toFixed(1)
          this.stats[0].lastMonth = r.data.tempoMedioConsultas[0].tempoMedioAtendimento.toFixed(1)
          this.stats[0].percentage = (((r.data.tempoMedioConsultas[1].tempoMedioAtendimento - r.data.tempoMedioConsultas[0].tempoMedioAtendimento) / r.data.tempoMedioConsultas[0].tempoMedioAtendimento) * 100).toFixed(1)
          r.data.tempoMedioConsultas[1].tempoMedioAtendimento - r.data.tempoMedioConsultas[0].tempoMedioAtendimento > 0
            ? (this.stats[0].detail = 'maior que o último mês', this.stats[0].colorPercentage = '#09ff00a1')
            : (this.stats[0].detail = 'menor que o último mês', this.stats[0].colorPercentage = 'red')

          this.stats[1].value = r.data.quantidadeMedicosCadastrados

          this.stats[2].value = r.data.tempoMedioConsultas[1].numeroDeAtendimentos
          this.stats[2].lastMonth = r.data.tempoMedioConsultas[0].numeroDeAtendimentos
          this.stats[2].percentage = (((r.data.tempoMedioConsultas[1].numeroDeAtendimentos - r.data.tempoMedioConsultas[0].numeroDeAtendimentos) / r.data.tempoMedioConsultas[0].numeroDeAtendimentos) * 100).toFixed(1)
          r.data.tempoMedioConsultas[1].numeroDeAtendimentos - r.data.tempoMedioConsultas[0].numeroDeAtendimentos > 0
            ? (this.stats[2].detail = 'maior que o último mês', this.stats[2].colorPercentage = '#09ff00a1')
            : (this.stats[2].detail = 'menor que o último mês', this.stats[2].colorPercentage = 'red')

          this.stats[3].value = r.data.numeroExamesSolicitados[1].totalExames
          this.stats[3].lastMonth = r.data.numeroExamesSolicitados[0].totalExames
          this.stats[3].percentage = (((r.data.numeroExamesSolicitados[1].totalExames - r.data.numeroExamesSolicitados[0].totalExames) / r.data.numeroExamesSolicitados[0].totalExames) * 100).toFixed(1)
          r.data.numeroExamesSolicitados[1].totalExames - r.data.numeroExamesSolicitados[0].totalExames > 0
            ? (this.stats[3].detail = 'maior que o último mês', this.stats[3].colorPercentage = '#09ff00a1')
            : (this.stats[3].detail = 'menor que o último mês', this.stats[3].colorPercentage = 'red')

          this.stats[4].value = r.data.numeroMedicamentosReceitados[1].totalMedicamentos
          this.stats[4].lastMonth = r.data.numeroMedicamentosReceitados[0].totalMedicamentos
          this.stats[4].percentage = (((r.data.numeroMedicamentosReceitados[1].totalMedicamentos - r.data.numeroMedicamentosReceitados[0].totalMedicamentos) / r.data.numeroMedicamentosReceitados[0].totalMedicamentos) * 100).toFixed(1)
          r.data.numeroMedicamentosReceitados[1].totalMedicamentos - r.data.numeroMedicamentosReceitados[0].totalMedicamentos > 0
            ? (this.stats[4].detail = 'maior que o último mês', this.stats[4].colorPercentage = '#09ff00a1')
            : (this.stats[4].detail = 'menor que o último mês', this.stats[4].colorPercentage = 'red')
        }
      }).finally(() => {
        this.load = false
      })
    },
    retornarTop5 () {
      this.load2 = true
      console.log('entraaa')
      medicoService.medico.retornarTop5(this.user.idUnidade).then(r => {
        if (r.status = 200) {
          console.log('top10 ', r.data)
          this.top5MediaAtendimentos = r.data.topFiveMediasMedicos
          this.top5Solicitacoes = r.data.topFiveSolicitacoesMedicos
        }
      }).finally(() => {
        this.load2 = false
      })
    }

  }

}

</script>
